module.exports = __webpack_public_path__ + "img/meatball-icon-2.324781da.svg";